import { isValidUrl } from "../../utils/customFunctions";

export const validatePeerSupportGroupData = ({
	title,
	description,
	topic,
	sessionDatetime,
	minSpots,
	maxSpots,
	reminderHoursBefore,
	feedbackSurveyId,
	feedbackSurveyTime,
	sessionLink,
}) => {
	const errors = {};
	const allowedReminderHours = [1, 6, 12, 24, 36, 48];

	if (!title || !title.en || title.en.trim() === "") {
		errors.title = {
			...errors.title,
			en: "English title is required",
		};
	} else if (title.en.length < 3 || title.en.length > 100) {
		errors.title = {
			...errors.title,
			en: "Title must be between 3 and 100 characters",
		};
	}

	if (!title || !title.ar || title.ar.trim() === "") {
		errors.title = {
			...errors.title,
			ar: "Arabic title is required",
		};
	} else if (title.ar.length < 3 || title.ar.length > 100) {
		errors.title = {
			...errors.title,
			ar: "Title must be between 3 and 100 characters",
		};
	}

	if (!description || !description.en || description.en.trim() === "") {
		errors.description = {
			...errors.description,
			en: "English description is required",
		};
	} else if (description.en.length < 10 || description.en.length > 500) {
		errors.description = {
			...errors.description,
			en: "Description must be between 10 and 500 characters",
		};
	}

	if (!description || !description.ar || description.ar.trim() === "") {
		errors.description = {
			...errors.description,
			ar: "Arabic description is required",
		};
	} else if (description.ar.length < 10 || description.ar.length > 500) {
		errors.description = {
			...errors.description,
			ar: "Description must be between 10 and 500 characters",
		};
	}

	if (!topic || !topic.en || topic.en.trim() === "") {
		errors.topic = {
			...errors.topic,
			en: "English topic is required",
		};
	} else if (topic.en.length < 3 || topic.en.length > 100) {
		errors.topic = {
			...errors.topic,
			en: "Topic must be between 3 and 100 characters",
		};
	}

	if (!topic || !topic.ar || topic.ar.trim() === "") {
		errors.topic = {
			...errors.topic,
			ar: "Arabic topic is required",
		};
	} else if (topic.ar.length < 3 || topic.ar.length > 100) {
		errors.topic = {
			...errors.topic,
			ar: "Topic must be between 3 and 100 characters",
		};
	}

	if (!sessionDatetime) {
		errors.sessionDatetime = "Session date and time is required";
	} else {
		const sessionDate = new Date(sessionDatetime);
		const now = new Date();
		if (sessionDate <= now) {
			errors.sessionDatetime = "Session must be scheduled for a future date and time";
		}
	}

	if (!minSpots && minSpots !== 0) {
		errors.minSpots = "Minimum spots is required";
	} else if (minSpots < 1) {
		errors.minSpots = "Minimum spots must be at least 1";
	} else if (!Number.isInteger(Number(minSpots))) {
		errors.minSpots = "Minimum spots must be an integer";
	}

	if (!maxSpots && maxSpots !== 0) {
		errors.maxSpots = "Maximum spots is required";
	} else if (maxSpots < 1) {
		errors.maxSpots = "Maximum spots must be at least 1";
	} else if (!Number.isInteger(Number(maxSpots))) {
		errors.maxSpots = "Maximum spots must be an integer";
	}

	if (minSpots && maxSpots && Number(minSpots) >= Number(maxSpots)) {
		errors.minSpots = "Minimum spots must be less than maximum spots";
		errors.maxSpots = "Maximum spots must be greater than minimum spots";
	}

	if (reminderHoursBefore === undefined || reminderHoursBefore === null) {
		errors.reminderHoursBefore = "Reminder time is required";
	} else if (!allowedReminderHours.includes(Number(reminderHoursBefore))) {
		errors.reminderHoursBefore = "Invalid reminder time. Must be 1, 6, 12, 24, 36, or 48 hours";
	}

	if (!feedbackSurveyId) {
		errors.feedbackSurveyId = "Feedback survey is required";
	}

	if (feedbackSurveyTime && sessionDatetime) {
		const feedbackDate = new Date(feedbackSurveyTime);
		const sessionDate = new Date(sessionDatetime);
		if (feedbackDate <= sessionDate) {
			errors.feedbackSurveyTime = "Feedback survey time must be after the session date/time";
		}
	}

	if (!sessionLink || sessionLink.trim() === "") {
		errors.sessionLink = "Session link is required";
	} else if (!isValidUrl(sessionLink)) {
		errors.sessionLink = "Please enter a valid URL (e.g. https://example.com)";
	}

	return errors;
};
